export default "__VITE_ASSET__Cm5bMumz__"